import variables from './variables.module.scss';
import themeVariables from './theme.module.scss';

type CSSVariableName = keyof typeof variables;
type ThemeVariableName = keyof typeof themeVariables;

export const getCSSVariable = (name: CSSVariableName): string => {
    return variables[name] || '';
};

export const getThemeVariable = (name: ThemeVariableName): string => {
    return themeVariables[name] || '';
};
